import axios from 'axios'
import { WEAVER_URL } from 'Global/constants'

export const startManualUpdate = user => {
  axios.get(`${WEAVER_URL}${'/api/v1/update'}`)
}
